import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { isKey } from '../../utils'
import { useTheme } from '../../theme'

import getStyles from './styles'

const variants = ['primary', 'alert', 'negative', 'clear']

interface IInfoBoxProps {
  children: React.ReactNode
  variant?: 'primary' | 'alert' | 'negative' | 'clear'
  flush?: boolean
  icon?: React.ComponentType<{ color?: string; style?: Rule }>
  style?: Rule
  bordered?: boolean
  padded?: boolean
}

/* eslint-disable react/no-array-index-key */
export function InfoBox({ children, variant, flush, icon: Icon, style, padded, bordered }: IInfoBoxProps) {
  const styles = getStyles(useTheme())
  return React.Children.toArray(children).length ? (
    <article
      {...css([
        styles.container.base,
        isKey(styles.container.variants, variant) && styles.container.variants[variant],
        flush && styles.container.flush,
        bordered && styles.container.bordered,
        padded && styles.container.padded,
        style,
      ])}
    >
      {React.Children.toArray(children).map((child, i, innerChildren) => (
        <div key={i} {...css([styles.content.base, i === innerChildren.length - 1 && styles.content.last])}>
          {Icon && <Icon color={variant} style={styles.icon.base} />}
          {child}
        </div>
      ))}
    </article>
  ) : null
}

InfoBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  variant: PropTypes.oneOf(variants),
  flush: PropTypes.bool,
  icon: PropTypes.func,
  style: PropTypes.object,
  bordered: PropTypes.bool,
  padded: PropTypes.bool,
}

InfoBox.defaultProps = {
  variant: 'primary',
  padded: true,
}

InfoBox.VARIANTS = variants
